import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Col, Form, Row } from 'antd';
import MainCard from 'components/MainCard';
import { ifrs16Config } from '../Configs/ifrs16Config';
import TableCellRenderer from '../Utils/TableCellRenderer';
import { constantFormValues } from '../../root';

const IFRS16FieldsModifications = ({ screen, handleInputMonthChange, rowIndex, initialChangeLength }) => {
	const form = Form.useFormInstance();
	// Determine which columns to display based on configuration
	const columnsToDisplay = constantFormValues?.changes?.orderedRowHeader || [];

	return (
		<Row gutter={[16, 0]}>
			<Col xs={24}>
				<Form.List name="changes">
					{(fields) => (
						<MainCard content={false} sx={{ mb: 2, mt: '12px', borderColor: '#d9d9d9' }}>
							<TableContainer sx={ifrs16Config.tableContainerStyles}>
								<Table sx={ifrs16Config.tableStyles}>
									<TableHead>
										<TableRow>
											{columnsToDisplay
												.map((key) => {
													const fieldConfig = constantFormValues?.changes?.changeList[key];
													// Skip if field configuration doesn't exist (commented out fields)
													if (!fieldConfig) return null;

													return (
														<TableCell
															key={fieldConfig.key}
															sx={{ fontSize: '14px', backgroundColor: '#e1f0ff !important' }}
															align="center"
														>
															{fieldConfig.label}
														</TableCell>
													);
												})
												.filter(Boolean)}
										</TableRow>
									</TableHead>
									<TableBody>
										{fields?.map((field, index) => (
											<TableRow key={field.key} style={{ height: '60px' }}>
												{/* Render cells based on column configuration */}
												{columnsToDisplay
													.map((configKey) => {
														const fieldConfig = constantFormValues?.changes?.changeList[configKey];
														// Skip if field configuration doesn't exist (commented out fields)
														if (!fieldConfig) return null;

														// Get the configuration for this column type
														const cellConfig = (() => {
															switch (configKey) {
																case 'inputChangeEffectiveDate': {
																	const isLastRow = index === fields.length - 1;
																	const isNewlyAddedRow = index >= initialChangeLength;
																	const shouldEnableEstimationDate =
																		screen === 'EDIT' && isLastRow && isNewlyAddedRow;
																	const baseCellConfig = ifrs16Config.cellConfigs.effectiveDate || {};
																	const baseComponentConfig = baseCellConfig.component || {};
																	const baseComponentProps = baseComponentConfig.props || {};

																	return {
																		...baseCellConfig,
																		component: {
																			...baseComponentConfig,
																			props: {
																				...baseComponentProps,
																				disabled: false,
																			},
																		},
																	};
																}
																case 'inputChangeRetirementDate':
																	return {
																		...ifrs16Config.cellConfigs.retirementDate,
																		component: {
																			...ifrs16Config.cellConfigs.retirementDate.component,
																			props: {
																				...ifrs16Config.cellConfigs.retirementDate.component.props,
																				disabled: true,
																			},
																		},
																	};
																case 'inputChangeRetirementTerm':
																	return {
																		...ifrs16Config.cellConfigs.retirementTerm,
																		component: {
																			...ifrs16Config.cellConfigs.retirementTerm.component,
																			props: {
																				...ifrs16Config.cellConfigs.retirementTerm.component.props,
																				disabled: true,
																			},
																		},
																	};
																case 'inputChangeDiscountRate':
																	return {
																		...ifrs16Config.cellConfigs.discountRate,
																		component: {
																			...ifrs16Config.cellConfigs.discountRate.component,
																			props: {
																				...ifrs16Config.cellConfigs.discountRate.component.props,
																				disabled: true,
																			},
																		},
																	};
																case 'inputChangeRetirementCost':
																	return {
																		...ifrs16Config.cellConfigs.retirementCost,
																		component: {
																			...ifrs16Config.cellConfigs.retirementCost.component,
																			props: {
																				...ifrs16Config.cellConfigs.retirementCost.component.props,
																				disabled: true,
																			},
																		},
																	};
																case 'inputChangeDescription':
																	return {
																		...ifrs16Config.cellConfigs.description,
																		component: {
																			...ifrs16Config.cellConfigs.description.component,
																			props: {
																				...ifrs16Config.cellConfigs.description.component.props,
																				disabled: true,
																			},
																		},
																	};
																default:
																	// For other fields, always disabled
																	return {
																		key: configKey,
																		component: {
																			type: 'input',
																			props: {
																				disabled: true,
																			},
																		},
																	};
															}
														})();

														return (
															<TableCellRenderer
																key={`${field.key}-${configKey}`}
																field={field}
																configKey={configKey}
																columnConfig={cellConfig}
																constantFormValues={constantFormValues}
																form={form}
																index={index}
																screen={screen}
																rowIndex={rowIndex}
																handleInputMonthChange={handleInputMonthChange}
															/>
														);
													})
													.filter(Boolean)}
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</MainCard>
					)}
				</Form.List>
			</Col>
		</Row>
	);
};

export default React.memo(IFRS16FieldsModifications);
